export default __webpack_public_path__ + "static/media/goalsEmptyState.27acbc04.svg";